export default __webpack_public_path__ + "static/image-69-ec641feab7aa75d387d30cb02d642388.jpg";